export default {
  "patient-12": "/videos/patient-12.mp4",
};
